import { Logger } from "./logger"

const errorMap: { [key: string]: string } = {
  api: `API is not supported under ${__platform} platform`,
}
export function throwErrorMsg(apiName: string, errorType = "api"): Error {
  if (!apiName) return
  throw Error(`【MAX-DSL】"max.${apiName}" ${errorMap[errorType]}`)
}
export function logWarnMsg(apiName: string, errorType = "api") {
  Logger.warn(`"max.${apiName}" ${errorMap[errorType]}`)
}
